<script lang="ts">
  import { Monitor, VerificationInput } from '$shared/components';
  import type { EntityParameterType } from '$shared/constants/EntityParameterType';

  interface Props {
    options?: any;
    custom?: import('svelte').Snippet;
    onmonitorconfigchange?: (config: any) => void;
    onverificationinputadd?: (param: EntityParameterType) => void;
    onverificationinputchange?: (param: any) => void;
  }

  let { options = {}, custom, onmonitorconfigchange, onverificationinputadd, onverificationinputchange }: Props = $props();

  const onConfigChange = (config: any): void => {
    onmonitorconfigchange?.(config);
  };

  const onClickAdd = (param: EntityParameterType): void => {
    onverificationinputadd?.(param);
  };

  const onChange = (param: any): void => {
    onverificationinputchange?.(param);
  };

  const custom_render = $derived(custom);
</script>

<div class="comp-form-inputs">
  {#if options?.monitor}
    <div class="monitor">
      <Monitor option={options.monitor} onchange={onConfigChange} />
    </div>
  {/if}
  {#if options?.monitor?.showMonitor}
    <div class="divider">{''}</div>
  {/if}
  {#if options?.verificationInput}
    <div class="verificationInput">
      <VerificationInput {...options?.verificationInput} onadd={onClickAdd} onchangeadditionalinput={onChange}>
        {#snippet custom()}
                <div class="cutom-form-input" >
            {@render custom_render?.()}
          </div>
              {/snippet}
      </VerificationInput>
    </div>
  {/if}
</div>

<style>
  .comp-form-inputs {
    background-color: var(--grey-bg);
    border-radius: 5px;
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--grey-xlight);
  }
</style>
